/**
 * Respuesta/cierre en estado FueraPlazo: misma filosofía que `tareaPdfAccess` para cuándo
 * confiar en `featureKeys` (solo con contexto `loaded`).
 *
 * Constante alineada con stem-web-backend CustomRoleFeatureKeys.taskRespondOverdue.
 */
const TASK_RESPOND_OVERDUE = 'taskRespondOverdue';

/** Lista blanca histórica: pueden enviar/cerrar tareas en FueraPlazo sin feature. */
export const TENANTS_CAN_RESPOND_OVERDUE_TASK: readonly string[] = [
  '65521df49b9fe3e8bb9fcfcf', // Pescadores Industriales
  '5ffc9b529e94bf0a6a9cde13', // Planiwise Pruebas
];

export function canRespondOverdueTask(
  tenantId: string | undefined,
  featureKeys: readonly string[],
): boolean {
  if (tenantId && TENANTS_CAN_RESPOND_OVERDUE_TASK.includes(tenantId)) {
    return true;
  }
  return featureKeys.includes(TASK_RESPOND_OVERDUE);
}

/**
 * Con contexto no `loaded`, no se aplica desbloqueo por feature (solo allowlist).
 * Si `tenantAccessContextLoadStatus === 'failed'`, mismo criterio conservador que sin features cargadas.
 */
export function canRespondOverdueTaskForUi(
  tenantId: string | undefined,
  featureKeys: readonly string[],
  tenantAccessContextLoadStatus: 'loaded' | 'failed' | null | undefined,
): boolean {
  if (tenantId && TENANTS_CAN_RESPOND_OVERDUE_TASK.includes(tenantId)) {
    return true;
  }
  if (tenantAccessContextLoadStatus === 'loaded') {
    return featureKeys.includes(TASK_RESPOND_OVERDUE);
  }
  return false;
}
